import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getTranslate, getActiveLanguage } from 'react-localize-redux'

import { getTopSellingProducts } from '../../store/customer'
import shop from '../../api/shop'

import { RingLoader } from 'react-spinners'
import { Table, Button, Form, FormGroup, Input, Label } from 'reactstrap'
import BuyingForm from './BuyingForm'
import { openProductModal, openOrderModal } from '../../store/product'
import ReactstrapImageGallery from '../../components/ReactstrapImageGallery'
import Moment from 'react-moment'
import { getCurrencySign } from '../../store/common'

class CustomerDetailSection extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loaded: false,
      loadingUser: false,
      loadingCommon: false,
      loadingPhotos: false,
      loadingOrders: false,
      note: null,
      images: [],
      orders: [],
    }
  }

  componentWillMount() {
    this.props.getTopSellingProductsList([], 'common')
    this.props.getTopSellingProductsList([], 'user')
    this.setState({ note: this.props.userNote })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.fetch && !!nextProps.topSellingProducts) {
      this.setState({ loaded: true })
      const { userId, topSellingProducts } = nextProps
      if (userId && !this.state.loaded) {
        if (this.state.orders.length === 0) {
          this.setState({ loadingOrders: true })
          shop.getLastCustomerOrder(userId, orderPromise => {
            orderPromise.then(list => {
              this.setState({ orders: list, loadingOrders: false })
            })
          })
        }
        if (this.state.images.length === 0) {
          this.setState({ loadingPhotos: true })
          shop.getofficeImages(userId, imagePromise => {
            imagePromise.then(list => {
              const listShrink = list.slice(0, 20)
              this.setState({ images: listShrink, loadingPhotos: false })
            })
          })
        }
        if (topSellingProducts.common.length === 0) {
          this.setState({ loadingCommon: true })
          shop.getCommonTopSellingProducts(userId, apiPromise => {
            apiPromise.then(list => {
              this.props.getTopSellingProductsList(list, 'common')
              this.setState({ loadingCommon: false })
            })
          }, 0)
        }
        if (topSellingProducts.user.length === 0) {
          this.setState({ loadingUser: true })
          shop.getUserTopSellingProducts(userId, apiPromise => {
            apiPromise.then(list => {
              this.props.getTopSellingProductsList(list, 'user')
              this.setState({ loadingUser: false })
            })
          }, 0)
        }
      }
    }
  }

  render() {
    const {
      topSellingProducts,
      translate,
      openProductModal,
      openOrderModal,
      userId,
      currencySign,
      cartList,
      actionType
    } = this.props

    const loader = (<div className='spinner'>
      <RingLoader
        color={'#d42e2b'}
        loading={this.state.loadingUser}
        size={50}
        margin={20}
      />
    </div>)

    const getOrderTable = (list) => {
      if (list.length == 0) {
        return (<Table>
          <thead>
            <tr>
              <th>#</th>
              <th>Dátum</th>
              <th>Autor</th>
              <th>Počet položiek</th>
              <th>Cena</th>
              <th>Dátum</th>
              <th />
            </tr>
          </thead>
          <tbody /></Table>)
      }
      const tableRows = list.map((order, index) => {
        return (
          <tr>
            <th scope='row'>{order.order_number}</th>
            <td>
              <Moment
                unix
                format='DD.MM.YYYY HH:MM:SS'
                date={order.date}
              />
            </td>
            <td>{order.oz ? 'OZ' : 'klient'}</td>
            <td>{order.amount}</td>
            <td>
              {parseFloat(order.price).toFixed(2)}{' '}
              {currencySign}
            </td>
            <td><Button color='link' onClick={() => openOrderModal(order.id)}>Zobraziť</Button></td>
          </tr>)
      })
      return <Table className='header__table'>
        <thead>
          <tr>
            <th>#</th>
            <th>Dátum</th>
            <th>Autor</th>
            <th>Počet položiek</th>
            <th>Cena</th>
            <th>Dátum</th>
            <th />
          </tr>
        </thead>
        <tbody>{tableRows}</tbody></Table>
    }

    const getTable = (list) => {
      if (list.length === 0) {
        return (<Table>
          <thead>
            <tr>
              <th>#</th>
              <th>Kod</th>
              <th>Počet nákupov</th>
              <th />
            </tr>
          </thead>
          <tbody /></Table>)
      }
      const tableRows = list.map((product, index) => {
        const cartProductIndex = cartList.findIndex(cp => cp.id === product.id)
        return (
          <tr>
            <th scope='row'>{++index}</th>
            <td><Button color='link' onClick={() => openProductModal(product.id)}>{product.code}</Button></td>
            <td>{product.selling}</td>
            {/* <td>{cartProductIndex !== -1 ? cartList[cartProductIndex].quantity : "-"}</td> */}
            {/* <td>{product.stock}</td> */}
            <td>
              <BuyingForm
                index={index}
                // title='Buy'
                productId={product.id}
                quantity={cartProductIndex !== -1 ? cartList[cartProductIndex].quantity : null}
                ozPrice={product.price}
                labelQnt={translate(
                  'molecules.containers.cartQuantityInput.quantiy_shorcode'
                )}
                disabled={product.stock <= 0 && actionType !== 'warehouse'}
              />
            </td>
          </tr>)
      })
      return <Table className='header__table'>
        <thead>
          <tr>
            <th>#</th>
            <th>Kod</th>
            <th>Počet nákupov</th>
            <th />
          </tr>
        </thead>
        <tbody>{tableRows}</tbody></Table>
    }

    return (
      <div className='row'>
        <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12'><h3>Polročný prehľad nákupov</h3></div>
        <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12'>
          <div className='row'>
            <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6'>
              <strong>Top produkty kupené zakazníkomk</strong>
              {this.state.loadingUser && (loader)}
              {!this.state.loadingUser && topSellingProducts.user && getTable(topSellingProducts.user)}
            </div>
            <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6'>
              <strong>Top predavané produkty mobilnetu</strong>
              {this.state.loadingCommon && (loader)}
              {!this.state.loadingCommon && topSellingProducts.common && getTable(topSellingProducts.common)}

            </div>
          </div>
        </div>
        <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12'><h3>Prehľad posledných objednávok zákazníka</h3></div>
        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6'>
          <div className='row'>
            <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12'>
              {this.state.loadingOrders && (loader)}
              {!this.state.loadingOrders && getOrderTable(this.state.orders)}
            </div>
          </div>
        </div>
        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6'>
          <Form>
            <FormGroup>
              <Label for='oz_note'>Poznámka</Label>
              <Input type='textarea' rows={5} name='text' id='oz_note' value={this.state.note} onChange={(e) => this.setState({ note: e.target.value })} />
            </FormGroup>
            <Button onClick={() => {
              shop.setOzUserNote(
                this.state.note,
                userId,
                () => { }
              )
            }}>Uložiť</Button>
          </Form>
          <br />
          {this.state.loadingPhotos && (loader)}
          {!this.state.loadingPhotos && <ReactstrapImageGallery images={this.state.images} limit={4} />}
        </div>
      </div >
    )
  }
};

const mapStateToProps = state => ({
  translate: getTranslate(state.locale),
  currentLanguage: getActiveLanguage(state.locale).id,
  userId: state.common.user.personal.id,
  userNote: state.common.user.personal.note,
  topSellingProducts: state.customer.topSellingProducts,
  currencySign: getCurrencySign(state.common.user.currency.sign),
  cartList: state.cart.list || [],
  actionType: state.customer.actionOnCustomer,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  getTopSellingProductsList: (list, type) => {
    dispatch(getTopSellingProducts(list, type))
  },
  openProductModal: id => dispatch(openProductModal(id)),
  openOrderModal: id => dispatch(openOrderModal(id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CustomerDetailSection)



// WEBPACK FOOTER //
// ./src/molecules/containers/CustomerDetailSection.js